import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  arrayMove,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";

import PageSections from "./PagesSections";
import { useFormContext } from "react-hook-form";
import { handleDragEndFactory } from "./dragUtils";

// Sortable Section Item
const DraggableSections = ({
  setDuplicateSection,
  setOpenModal,
  sectionRows,
  setSelectSectionId,
  selectionId,
  setType,
  type,
  fields,
  move,
  remove,
  duplicateSection,
}) => {
  const sensors = useSensors(useSensor(PointerSensor));
  const { getValues, setValue } = useFormContext(); // <-- get form methods here

  const handleRemoveSection = (sectionId) => {
    const idx = fields.findIndex((f) => f.sectionId === sectionId);
    if (idx !== -1) remove(idx);
  };

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={handleDragEndFactory(fields, move, getValues, setValue)} // ✅ extracted
    >
      <SortableContext
        items={fields.map((f) => f.id)}
        strategy={verticalListSortingStrategy}
      >
        {fields.map((section, index) => (
          <PageSections
            key={section.id}
            id={section.id}
            index={index}
            sectionId={section.sectionId}
            handleRemoveSection={handleRemoveSection}
            setOpenModal={setOpenModal}
            sectionRows={sectionRows}
            setSelectSectionId={setSelectSectionId}
            selectionId={selectionId}
            type={type}
            setType={setType}
            duplicateSection={duplicateSection}
            setDuplicateSection={setDuplicateSection}
          />
        ))}
      </SortableContext>
    </DndContext>
  );
};

export default DraggableSections;
